module.exports = __webpack_public_path__ + "static/media/logo-white-sub.dc2e0767.png";